<template>
<loader v-bind="{ loading }">
  <div class="columns">
    <div class="column has-text-right">
      <action-button @click="addNewDistribution" class="is-small is-rounded" left-icon="plus">Distribution</action-button>
    </div>
  </div>
  <table class="table is-fullwidth">
    <thead>
      <tr>
        <th>Distribution</th>
        <th>Identifier</th>
        <th>Version Retriever</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="distribution in software.distributions" :key="distribution.id">
        <td>
          <a @click="edit(distribution)">
            {{ distribution.name }}
          </a>
        </td>
        <td>{{ distribution.distribution.identifier }}</td>
        <td>{{ distribution.distribution.version_retriever }}</td>
      </tr>
    </tbody>
  </table>
</loader>  
</template>
<script>
import { mapGetters } from 'vuex'
import { newSoftwareDistribution, editSoftwareDistribution } from '@/modals'
 
export default {
  data: () => ({
    loading: true
  }),

  created() {
    this.$store.dispatch('software/loadDistributions', this.$route.params.software).then(() => {
      this.loading = false
    })
  },

  methods: {
    addNewDistribution() {
      newSoftwareDistribution()
    },
    edit(distribution) {
      editSoftwareDistribution(distribution)
    }
  },

  computed: {
    ...mapGetters('software', [
      'software'
    ])
  }
}
</script>